import { useEffect } from 'react';

interface UsePhoneClientMenuEffectsProps {
  open: boolean;
  updateMenuWidthHandler(): void;
}

export const usePhoneClientMenuEffects = ({
  open,
  updateMenuWidthHandler,
}: UsePhoneClientMenuEffectsProps) => {
  useEffect(() => {
    if (!open) return;

    updateMenuWidthHandler();
    window.addEventListener('resize', updateMenuWidthHandler);

    return () => {
      window.removeEventListener('resize', updateMenuWidthHandler);
    };
  }, [open, updateMenuWidthHandler]);
};
